import { render, staticRenderFns } from "./BaseTableActions.vue?vue&type=template&id=03fce20a&scoped=true"
import script from "./BaseTableActions.vue?vue&type=script&lang=js"
export * from "./BaseTableActions.vue?vue&type=script&lang=js"
import style0 from "./BaseTableActions.vue?vue&type=style&index=0&id=03fce20a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fce20a",
  null
  
)

export default component.exports